import { useCallback, useContext, useEffect } from 'react';

import { Tabs } from '@hdi-seguros/web-components.tabs';

import { CivilPaymentMethods } from '../PaymentMethods';
import { Form } from '../../../../../../../../../shared/components';
import {
  GenericDataFormContext,
  QUOTATION_BUTTON,
  QuotationInfoContext,
  QuotationStep,
  QuotationStepButtons,
} from '../../../../../shared';
import { Summary } from '../Summary';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';

import {
  generateInputID,
  getCoverageAndActivityKeyByID,
} from '../../../../../AP/Steps/StepThree/components/Quotation/utils';

export const CivilQuotation = () => {
  const {
    clearPrimaFieldsOnFormChange,
    labelButton,
    quotationResponse,
    setLabelButton,
    stepThreeCivilQuotationForm,
    createTabs,
    quotationTabs,
    activeTab,
    setActiveTab,
    handlerOnClick,
  } = useContext(StepThreeFormContext);
  const { allCoveragesPerPlan, setFormValues } = useContext(GenericDataFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const onPressBackButton = useCallback(async () => {
    setFormValues(stepThreeCivilQuotationForm.getFieldsValue());
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.TWO);
  }, [
    setCurrentStep, 
    quotationResponse, 
    setLabelButton,
    setFormValues,
    stepThreeCivilQuotationForm,
  ]);

  const onChangeForm = useCallback(
    (changedFields: any[]) => {
      if (quotationResponse) {
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
        clearPrimaFieldsOnFormChange();
      }

      const nameOfFieldChanged: string = changedFields[0].name[0];
      const valueChanged = changedFields[0].value;

      const { activityKey, id } =
        getCoverageAndActivityKeyByID(nameOfFieldChanged);

      const tabKey = activityKey.split('-')[2];

      const planSelected = stepThreeCivilQuotationForm.getFieldValue(
        `plan-tab-${tabKey}`
      );

      const allCoveragesByTab = allCoveragesPerPlan.find(
        (el) => (el.plan as string) === String(planSelected)
      )?.coverages;

      const coverageCode = allCoveragesByTab?.find(
        (el) => el.id === id
      )?.codigo;

      if (coverageCode) {
        const relatedCoverages = allCoveragesByTab?.filter(
          (el) => el.codigoCoberturaRelacionada === coverageCode
        );

        relatedCoverages.forEach(({ id, porcentajeSumaAsegegurada }) => {
          const checkboxName = generateInputID(id, activityKey, 'checkbox');
          if (stepThreeCivilQuotationForm.getFieldValue(checkboxName)) {
            const inputName = generateInputID(id, activityKey);
            stepThreeCivilQuotationForm.setFieldValue(
              inputName,
              Math.round(
                valueChanged * (Number(porcentajeSumaAsegegurada) / 100)
              )
            );
          }
        });
      }
    },
    [
      setLabelButton,
      allCoveragesPerPlan,
      stepThreeCivilQuotationForm,
      quotationResponse,
      clearPrimaFieldsOnFormChange,
    ]
  );

  useEffect(() => {
    createTabs();
    setActiveTab(1);
  }, [createTabs]);

  return (
    <>
      <Form
        formProps={{
          form: stepThreeCivilQuotationForm,
          name: 'quotation-civil-tab-form',
          onFieldsChange: onChangeForm,
        }}
      >
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={quotationTabs}
        />
      </Form>

      {quotationResponse && (
        <>
          <CivilPaymentMethods />

          <Summary />
        </>
      )}

      <QuotationStepButtons
        label={labelButton}
        onClick={handlerOnClick}
        onPressBackButton={onPressBackButton}
      />
    </>
  );
};
